import { Button, Typography } from '@breetometer/components';
import { PinManagement } from 'BreetComponents';
import { useCallback, useState } from 'react';

import Child from './Child';
import type { IFormPinValidation } from './FormPinValidation.helpers';

const FormPinValidation = ({ onSuccess, type, error, clearError }: IFormPinValidation) => {
	const [isResetPin, setIsResetPin] = useState(false);

	const onHandleIsResetPin = useCallback(
		(reset: boolean) => () => {
			setIsResetPin(reset);
		},
		[]
	);

	return (
		<>
			{!isResetPin ? (
				<Child
					onSuccess={onSuccess}
					type={type}
					error={error}
					clearError={clearError}
					onResetPin={onHandleIsResetPin(true)}
				/>
			) : (
				<div className='reset-pin-container'>
					<div className='reset-pin-header'>
						<Typography
							as='h4'
							className='color-tertiary-400'
						>
							Reset PIN
						</Typography>
					</div>
					<PinManagement
						mode='reset'
						onSuccess={onHandleIsResetPin(false)}
						isModal
					/>
					<div className='cancel-cta'>
						<Button
							variant='native'
							onClick={onHandleIsResetPin(false)}
							className='danger-txt-link-hover'
						>
							Cancel
						</Button>
					</div>
				</div>
			)}
		</>
	);
};

export default FormPinValidation;
